import classNames from 'classnames';
import he from 'he';
import fp from 'lodash/fp';
import React from 'react';
import { Col, Collapse, Row } from 'react-bootstrap';
import { FiCheck } from 'react-icons/fi';
import { lifecycle, withHandlers, withStateHandlers } from 'recompose';
import { compose } from 'redux';
import { Icon } from '../..';
import ToggleBox from '../../toggle-box';
import { filterNonLegacy } from '../../../../common/cpd-category-filter';

const CpdCategoryFilter = ({
  onCpdCategoryFilterChange,
  toggleFilter,
  showFilter,
  cpdCategorys
}) => {
  return (
    <div className='filter cpd-category-filter'>
      <Row className='button-gutter'>
        <Col xs={12}>
          <h2
            className='flexbox'
            type='button'
            onClick={toggleFilter}
            aria-expanded={showFilter}
            aria-controls='filter'
          >
            {showFilter ? (
              <Icon icon='minus-large'></Icon>
            ) : (
              <Icon icon='plus-large'></Icon>
            )}
            <span id='label'>CPD Category</span>
          </h2>
        </Col>
      </Row>
      <Row className='no-gutter'>
        <Collapse id='cpd-category-filter' in={showFilter}>
          <div>
            <form id='selection-list'>
              <div>
                {fp.flow(
                  fp.sortBy((cpdCategory) => cpdCategory.name),
                  fp.map(({ id, name, selected }) => {
                    const boxLabel = selected ? <FiCheck /> : null;
                    return (
                      <Row
                        className={classNames('no-gutter', { selected })}
                        id='selection'
                        key={id}
                        onClick={() => {
                          onCpdCategoryFilterChange(id);
                        }}
                      >
                        <span id='checkbox'>
                          <ToggleBox
                            small
                            value={id}
                            label={boxLabel}
                            checked={selected}
                          />
                        </span>
                        <span>{he.decode(name)}</span>
                      </Row>
                    );
                  })
                )(cpdCategorys)}
              </div>
            </form>
          </div>
        </Collapse>
      </Row>
    </div>
  );
};

const getUpdatedCpdCategorys = (cpdCategorys, cpdCategoryIdToToggle) =>
  fp.flow(
    fp.map((cpdCategory) => ({
      ...cpdCategory,
      selected:
        cpdCategory.id === cpdCategoryIdToToggle
          ? !cpdCategory.selected
          : cpdCategory.selected
    }))
  )(cpdCategorys);

export default compose(
  withStateHandlers(
    {
      showFilter: false
    },
    {
      toggleFilter:
        ({ showFilter }) =>
        () => ({
          showFilter: !showFilter
        })
    }
  ),
  withStateHandlers(
    ({ cpdCategorys }) => ({
      cpdCategorys: fp.flow(
        filterNonLegacy,
        fp.map((cpdCategory) => ({
          ...cpdCategory,
          selected: false
        }))
      )(cpdCategorys)
    }),
    {
      setCpdCategorys: () => (cpdCategorys) => ({
        cpdCategorys
      }),
      resetCpdCategorys:
        ({ cpdCategorys }) =>
        ({ cpdCategoryIds }) => ({
          cpdCategorys: fp.flow(
            filterNonLegacy,
            fp.map((cpdCategory) => ({
              ...cpdCategory,
              selected: fp.includes(cpdCategory.id)(cpdCategoryIds)
            }))
          )(cpdCategorys)
        })
    }
  ),
  withHandlers({
    onCpdCategoryFilterChange:
      ({ onChange, cpdCategorys, setCpdCategorys }) =>
      (cpdCategoryId) => {
        const updatedCpdCategorys = getUpdatedCpdCategorys(
          cpdCategorys,
          cpdCategoryId
        );
        setCpdCategorys(updatedCpdCategorys);
        const selectedCpdCategoryIds = fp.flow(
          fp.filter('selected'),
          fp.map('id')
        )(updatedCpdCategorys);
        onChange({
          cpdCategoryIds: selectedCpdCategoryIds
        });
      }
  }),
  lifecycle({
    componentDidUpdate(prevStat) {
      const { filter, resetCpdCategorys } = this.props;
      if (!fp.isEqual(filter)(prevStat.filter)) {
        resetCpdCategorys(filter);
      }
    }
  })
)(CpdCategoryFilter);



// WEBPACK FOOTER //
// ./src/containers/components/filters/partials/cpd-category-filter.js